"use client"

import { useState, useCallback } from "react"

export const useFormValidation = () => {
  const [errors, setErrors] = useState<Record<string, string>>({})

  const clearErrors = useCallback(() => {
    setErrors({})
  }, [])

  const clearError = useCallback((field: string) => {
    setErrors((prev) => {
      const newErrors = { ...prev }
      delete newErrors[field]
      return newErrors
    })
  }, [])

  const setError = useCallback((field: string, message: string) => {
    setErrors((prev) => ({ ...prev, [field]: message }))
  }, [])

  const hasErrors = Object.keys(errors).length > 0

  return {
    errors,
    setError,
    clearError,
    clearErrors,
    hasErrors,
  }
}
